export type ConstTextStyle = {
  fontSize: number | string;
  fontWeight: number | string;
  lineHeight: number | string;
};

export class ConstFontWeight {
  public static readonly REGULAR = "normal";
  public static readonly BOLD = "bold";
}

export class ConstFontStyle {
  public static readonly HeadlineLarge: ConstTextStyle = {
    fontSize: "30px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "42px",
  };
  public static readonly HeadlineMiddle: ConstTextStyle = {
    fontSize: "22px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "30px",
  };
  public static readonly HeadlineSmall: ConstTextStyle = {
    fontSize: "18px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "30px",
  };
  public static readonly ValueLarge: ConstTextStyle = {
    fontSize: "26px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "36px",
  };
  public static readonly ParagraphDefault: ConstTextStyle = {
    fontSize: "15px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "24px",
  };
  public static readonly MenuParagraphDefault: ConstTextStyle = {
    fontSize: "13px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "24px",
  };
  public static readonly ParagraphSup: ConstTextStyle = {
    fontSize: "12px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "18px",
  };
  public static readonly ErrorTextDefault: ConstTextStyle = {
    fontSize: "13px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "24px",
  };
  public static readonly FormDefault: ConstTextStyle = {
    fontSize: "16px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "23px",
  };
  public static readonly BtnSmall: ConstTextStyle = {
    fontSize: "12px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "17px",
  };
  public static readonly BtnMiddle: ConstTextStyle = {
    fontSize: "15px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "22px",
  };
  public static readonly BtnLarge: ConstTextStyle = {
    fontSize: "15px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "22px",
  };
  public static readonly LabelJob: ConstTextStyle = {
    fontSize: "9px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "13px",
  };
  public static readonly BadgeBorder: ConstTextStyle = {
    fontSize: "10px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "14px",
  };

  public static readonly LabelDefault: ConstTextStyle = {
    fontSize: "14px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "16px",
  };
  public static readonly TutorialLarge: ConstTextStyle = {
    fontSize: "40px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "52px",
  };

  public static readonly SpHeadlineLarge: ConstTextStyle = {
    fontSize: "24px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "30px",
  };
  public static readonly SpHeadlineMiddle: ConstTextStyle = {
    fontSize: "18px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "30px",
  };
  public static readonly SpHeadlineSmall: ConstTextStyle = {
    fontSize: "16px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "24px",
  };
  public static readonly SpParagraphDefault: ConstTextStyle = {
    fontSize: "14px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "24px",
  };
  public static readonly SpParagraphSup: ConstTextStyle = {
    fontSize: "11px",
    fontWeight: ConstFontWeight.REGULAR,
    lineHeight: "18px",
  };
  public static readonly SpTutorialLarge: ConstTextStyle = {
    fontSize: "20px",
    fontWeight: ConstFontWeight.BOLD,
    lineHeight: "24px",
  };
}

export const ConstMargin = {
  HeadlineIconRight: "15px",
  ParagraphIconRight: "10px",

  HeadlineLargeBottom: "50px",
  SpHeadlineLargeBottom: "30px",

  HeadlineMiddleBottom: "20px",
  SpHeadlineMiddleBottom: "20px",

  SpHeadlineSmallBottom: "10px",
  HeadlineSmallBottom: "10px",

  SpParagraphBottom: "10px",
  ParagraphBottom: "10px",

  SpParagraphSupBottom: "10px",
  ParagraphSupBottom: "10px",

  LabelBottom: "5px",

  MenuItemRight: "15px",
  MenuItemLeft: "15px",

  TableBorder: "4px",
};

export const ConstBorderRound = {
  CornerRoundAll: "3px",
  CornerRoundRightTopRightBottom: "0 3px 3px 0",
  CornerRoundLeftTopLeftBottom: "3px 0 0 3px",
  CornerRoundLeftBottomRightBottom: "0 0 3px 3px",
  CornerRoundLeftTopRightTop: "3px 3px 0 0",
  CornerRoundNon: 0,

  MessageRoomCard: "5px",
  CornerRoundAll5: "5px",

  CustomerExternalContract: "5px",
  MenuProfile: "5px",
  BadgeBorder: "21px",
  AuthBorder: "10px",
  LabelUnreadCount: "30px",
};

export const ConstWidth = {
  ContentsMaxWidth: "960px",
  TableThWidth: "140px",
  MenuWidth: "210px",

  PagePaddingLeftSp: "20px",
  PagePaddingRightSp: "20px",
  PagePaddingLeftTablet: "50px",
  PagePaddingRightTablet: "50px",
  PagePaddingLeftPc: "50px",
  PagePaddingRightPc: "50px",
};

export const ConstHeight = {
  HeaderHeight: "60px",
  HeaderHeightSp: "50px",

  PagePaddingTop: "20px",
  PagePaddingTopSp: "30px",
  PagePaddingBottomSp: "50px",
  PagePaddingBottom: "100px",

  ProjectThumbnail: "280px",
};

export const ConstPadding = {
  FormDefaultPadding: "8px 20px",
  FormTextAreaPadding: "14px 20px",
};

export const ConstBreakPoint = {
  Default: "768px",

  PcDeskTop: "1200px",
};

export const ConstColor = {
  LiberaColor: "#d50080",
  Corporate: "#9A8C64",
  Base: "#333333",
  DeepBlack: "#1D1E1F",
  BgGray: "#FBFBFB",
  FooterBg: "#EEF0F3",
  Gray: "#A4A4A4",
  PlaceholderAndBorder: "#D8D8D8", // borderと兼用になる？
  LightGray: "#EEEEEE",
  Readonly: "#EEEEEE",
  Error: "#CE4141",
  Success: "#00D58E",
  Focus: "#C19721",
  Yellow: "#F1FDAA",
  // Border      : "#D8D8D8",
  White: "#FFFFFF",
  Scout: "#D50080",
  TableTh: "#EAEBF7",
  TableTd: "#FDFDFD", // 仮の名前
  TableThGray: "#F1F6F8",
  Favorite: "#E8437E",

  Current: "#9A8C64",
  CurrentDeep: "#807350",

  LightBlack: "#242526",

  Hr: "#C4C4C4",
  GreenGray: "#F0F4F3",

  circleProgressColorGreen: "#00D58E",
  circleBgColorGreen: "#A3E2CD",
  circleProgressColorYellow: "#F0CE60",
  circleBgColorYellow: "#EBDEBA",
  circleProgressColorRed: "#ED5256",
  circleBgColorRed: "#EABBBD",
  //
  NoticeInfo: "rgba(0, 213, 142, 0.9)",
  NoticeWarn: "rgba(255, 212, 0, 0.9)",
  NoticeError: "rgba(241, 51, 51, 0.9)",
};

export const ConstZIndex = {
  layout: 999,
  menu: 901,
  notificationCenter: 902,
  progress: 900,
  modal: 1000,
  hamburgerMenu: 1100,
  hamburgerOverlay: 1001,
  overlay: 300,
  customerNotification: 100,
  messageRoomProject: 100,
  pagination: 3,
  clientProfileUpdateRole: 2,
};

export const ConstShadow = {
  DropShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
  BorderTopBottom: `inset 0px -1px 0px ${ConstColor.LightGray}, inset 0px 1px 0px ${ConstColor.LightGray}`,
  BorderBottom: `0px 1px 0px 0px ${ConstColor.LightGray}`,
};

export const ConstCalc = {
  PageWrapperMinHeight: `calc(100vh - ${ConstHeight.HeaderHeight} - ${ConstHeight.PagePaddingTop} - ${ConstHeight.PagePaddingBottom})`,
  PageWrapperMinHeightSp: `calc(100vh - ${ConstHeight.HeaderHeightSp} - ${ConstHeight.PagePaddingTopSp} - ${ConstHeight.PagePaddingBottomSp})`,

  // sp, tablet時にはメニューの横幅を入れない
  CustomerSlideMaxWidthSp: `calc(90vw - ${ConstWidth.PagePaddingRightSp} - ${ConstWidth.PagePaddingLeftSp})`,
  CustomerSlideMaxWidthTablet: `calc(90vw - ${ConstWidth.PagePaddingLeftTablet} - ${ConstWidth.PagePaddingRightTablet})`,
  CustomerSlideMaxWidthPc: `calc(90vw - ${ConstWidth.PagePaddingLeftPc} - ${ConstWidth.PagePaddingRightPc} - ${ConstWidth.MenuWidth})`,
};



// WEBPACK FOOTER //
// ./src/config/styles_const/styles_const.ts